import React from 'react'
import { object, string } from 'prop-types'
let tripAppNameArr = []

class HotelParkingInformation extends React.Component {
  showRelatedProductDetails (product = {}) {
    if (
      !product.hasOwnProperty('tripapphotelname') ||
      !product.hasOwnProperty('tripapptransferstory') ||
      !product.hasOwnProperty('room_only_code') ||
      !product.room_only_code.length ||
      (product.hasOwnProperty('_a_equivalent_flex_products') && product._a_equivalent_flex_products.length)
    ) {
      return false
    }
    const lcName = product.tripapphotelname.toLowerCase()
    const mgRegex = /meet.+?greet/g
    const prRegex = /park.+?ride/g
    if (
      lcName.indexOf('breakfast') > -1 ||
      lcName.indexOf('lunch') > -1 ||
      lcName.indexOf('dinner') > -1 ||
      (lcName.indexOf('parking') === -1 && !mgRegex.test(lcName) && !prRegex.test(lcName)) ||
      tripAppNameArr.hasOwnProperty(lcName)
    ) {
      return false
    }
    tripAppNameArr[lcName] = true
    return tripAppNameArr[lcName]
  }

  render () {
    const { productData, id } = this.props
    const relatedProducts = productData.hasOwnProperty('relatedProductsProdlibDetails') ? productData.relatedProductsProdlibDetails : null

    return (
      <div id={id}>

        { productData.hasOwnProperty('tripapphotelname') && productData.hasOwnProperty('tripapptransferstory') && (
          <div>
            <h2>{ productData.tripapphotelname + ' room-only procedures' }</h2>
            <div dangerouslySetInnerHTML={{ __html: productData.tripapptransferstory }} />
          </div>
        ) }

        { relatedProducts !== null && Object.keys(relatedProducts).map((code, index) => {
          if (this.showRelatedProductDetails(relatedProducts[code])) {
            return (
              <div key={index}>
                <h2>{ relatedProducts[code].tripapphotelname }</h2>
                <div dangerouslySetInnerHTML={{ __html: relatedProducts[code].tripapptransferstory }} />
              </div>
            )
          }
        }) }

      </div>
    )
  }
}

HotelParkingInformation.propTypes = {
  productData: object,
  id: string
}

HotelParkingInformation.defaultProps = {
  productData: { }
}

export default HotelParkingInformation



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/specificProduct/hotelParkingInformation.jsx